import type { OwnerWorkspaceAsset } from 'config/api/assetRopa/assetRopaWorkspace.types';
import type { AssetRopaReview } from 'config/api/ropaReviews/ropaReviews.types';

const resolveMenuActions = (asset: OwnerWorkspaceAsset): Record<string, boolean> => {
  if (!asset.reviewOverlay || !asset.includedInCurrentReview) {
    return {};
  }

  const rows = asset.reviewOverlay.processingActivityReviews;
  const hasSubmitted = rows.some(row => row.reviewStatus === 'submitted' || row.canAccept);
  const canClarify = rows.some(row => row.canRequestClarification || row.reviewStatus === 'submitted');
  const hasIncomplete = rows.some(row => row.reviewStatus !== 'accepted' && row.reviewStatus !== 'cancelled');

  return {
    ...asset.menuActions,
    accept_all_submitted: asset.menuActions.accept_all_submitted ?? hasSubmitted,
    request_clarification: asset.menuActions.request_clarification ?? canClarify,
    cancel_incomplete_asset_review: asset.menuActions.cancel_incomplete_asset_review ?? hasIncomplete,
  };
};

export const mapOrganizationWorkspaceAssetToReview = (asset: OwnerWorkspaceAsset): AssetRopaReview => {
  const overlay = asset.reviewOverlay;

  return {
    id: asset.assetRopaId,
    assetRopaId: asset.assetRopaId,
    assetId: asset.assetId,
    assetName: asset.assetName,
    assetTypeId: asset.assetTypeId,
    assetTypeName: asset.assetTypeName,
    operationalOwnerMembershipId: asset.operationalOwnerMembershipId,
    operationalOwnerName: asset.operationalOwnerName,
    processingActivitiesCount: asset.processingActivitiesCount,
    permanentRopaStatus: overlay?.permanentRopaStatus ?? asset.permanentRopaStatus,
    reviewStatus: overlay?.reviewStatus ?? 'awaiting_response',
    warnings: overlay?.warnings ?? asset.warnings,
    processingActivityReviews:
      overlay && overlay.processingActivityReviews.length > 0 ? overlay.processingActivityReviews : asset.processingActivityReviews,
    menuActions: resolveMenuActions(asset),
    gdprRelevanceStatus: asset.gdprRelevanceStatus,
    informationalCompleteness: asset.informationalCompleteness,
    lastUpdatedAt: asset.lastUpdatedAt,
    lastUpdatedByName: asset.lastUpdatedByName,
    includedInCurrentReview: asset.includedInCurrentReview,
    hasReviewOverlay: Boolean(overlay),
    assetRopaReviewId: overlay?.assetRopaReviewId ?? null,
  };
};

export const resolveAssetRopaReviewId = (asset: AssetRopaReview): number | null => asset.assetRopaReviewId ?? null;
